<template>
  error
</template>

<script>
export default {
    name: "error-page"
}
</script>

<style>

</style>